module.exports = __webpack_public_path__ + "img/CM-MC-25-Buick-Lifestyle.878c41d9.jpg";